import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Row, Col, Badge } from 'antd'
import { withTranslation } from 'react-i18next'
import { createBrowserHistory } from 'history';
import HomeIcon from '@material-ui/icons/Home';
import ChatIcon from '@material-ui/icons/Chat';
import OrderIcon from '@material-ui/icons/List';

const STAYCHAT_WS_URL = process.env.REACT_APP_STAYCHAT_WS;
const isDisableBot = process.env.REACT_APP_STAYCHAT_BOT_DISABLE !== "false";
let scws = null;
let scwsUser = '';

@inject(
    'templateStore',
    'webSettingStore',
    'translationStore',
    'chatStore'
)
@observer
class FooterMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.scwsConnect();
    }

    scwsConnect() {
        if (!STAYCHAT_WS_URL) return;

        this.props.chatStore.sync();

        const roomNo = JSON.parse(window.localStorage.getItem('roomNo'));
        const customerId = window.localStorage.getItem('customerId');
        scwsUser = `staymenu_${customerId}`;

        const token = window.btoa(scwsUser + ":" + roomNo);
        const url = `${STAYCHAT_WS_URL}?access_token=${token}`;
        scws = new WebSocket(url);

        scws.onopen = () => {
            console.log("StayChat WebSocket are opened");
            this.scwsHeartbeat();
        };

        scws.onmessage = (data) => {
            console.log("StayChat WebSocket message received");

            var obj = eval('(' + data.data + ')');

            if (!obj) {
                console.log("StayChat WebSocket message empty");
                return;
            }

            if (obj.Action === "heartbeat") {
                console.log("heartbeat");
                return;
            }

            if (obj.Action === "StayChatSync") {
                const history = createBrowserHistory();

                if (history.location.pathname.includes('chat')) {
                    if (obj.Data?.IsReplied) this.props.chatStore.setKeepLoading(false);
                    this.props.chatStore.reload();
                    this.props.chatStore.read();
                }
                else {
                    this.props.chatStore.sync();
                }
            }

            // Play audio if from ChatBot
            if (!isDisableBot && obj.Action === "SendMessage" && obj.Data && obj.Data.Sender === "ChatBot" && obj.Data.AudioUrl) {
                const player = new Audio(obj.Data.AudioUrl);
                player.play();
            }
        };

        scws.onclose = (code, reason) => {
            console.log("StayChat WebSocket are closed." + code.code + " Reason:" + reason);
            setTimeout(this.scwsHeartbeat, 3000);
        };

        scws.onerror = (err) => {
            console.error('StayChat WebSocket encountered error: ', err.message, 'Closing socket');
            scws.close();
        };

        this.scwsHeartbeat();
    }

    scwsHeartbeat() {
        if (!scws || scws.readyState !== 1) return;

        var obj = {
            Action: "heartbeat",
            Account: { Username: scwsUser }
        };
        scws.send(JSON.stringify(obj));
        setTimeout(this.scwsHeartbeat, 30000);
    }

    homeClicked = () => {
        this.props.history.push('./');
    }

    chatClicked = () => {
        if (window.location.pathname === "/chat") return;
        this.props.history.push('./chat');
    }

    orderClicked = () => {
        this.props.history.push('./order');
    }

    componentWillUnmount() {
        clearInterval(this.myInterval);
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const menuText = this.props.menuText
        const { unreadChatCount } = this.props.chatStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        <Row>
                                            <Col span={24} className='stm-footer' style={{
                                                width: 'calc(100% - 40px)', left: 20,
                                                borderRadius: 32,
                                                boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.12)',
                                                marginBottom: '10px'
                                            }}>
                                                <Row>
                                                    <Col
                                                        span={STAYCHAT_WS_URL ? 8 : 12}
                                                        onClick={this.homeClicked}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            paddingTop: 14,
                                                            paddingBottom: 14,
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        {
                                                            menuText === 'home' ?
                                                                <HomeIcon
                                                                    style={{
                                                                        color: activeTemplate.templateSetting.footer.backgroundColor,
                                                                        fontSize: 24
                                                                    }}
                                                                />
                                                                :
                                                                <HomeIcon
                                                                    style={{
                                                                        fontSize: 24
                                                                    }}
                                                                />
                                                        }
                                                        <span style={{
                                                            marginLeft: 6,
                                                            fontFamily: activeTemplate.templateSetting.footer.fontFamily,
                                                            color: menuText === 'home' ? activeTemplate.templateSetting.footer.backgroundColor : activeTemplate.templateSetting.text.backgroundColor,
                                                            fontSize: activeTemplate.templateSetting.footer.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.footer.fontSize}px`
                                                        }}>
                                                            {webSettting.homeText}
                                                        </span>
                                                    </Col>
                                                    {
                                                        STAYCHAT_WS_URL ?
                                                            <Col
                                                                span={8}
                                                                onClick={this.chatClicked}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    paddingTop: 14,
                                                                    paddingBottom: 14,
                                                                    cursor: 'pointer',
                                                                    position: 'relative'
                                                                }}
                                                            >
                                                                <span style={{
                                                                    position: 'absolute',
                                                                    left: 0,
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    width: 2,
                                                                    height: (activeTemplate.templateSetting.footer.fontSize || 16) + 'px',
                                                                    backgroundColor: '#D9D9D9',
                                                                    borderRadius: 1
                                                                }} />
                                                                {
                                                                    menuText === 'chat'
                                                                        ?
                                                                        <ChatIcon
                                                                            style={{
                                                                                color: activeTemplate.templateSetting.footer.backgroundColor,
                                                                                fontSize: 20
                                                                            }}
                                                                        />
                                                                        :
                                                                        <Badge
                                                                            count={unreadChatCount}
                                                                            className='stm-badge-chat'
                                                                        >
                                                                            <ChatIcon
                                                                                style={{
                                                                                    fontSize: 20
                                                                                }}
                                                                            />
                                                                        </Badge>
                                                                }
                                                                <span style={{
                                                                    marginLeft: 6,
                                                                    fontFamily: activeTemplate.templateSetting.footer.fontFamily,
                                                                    color: menuText === 'chat' ? activeTemplate.templateSetting.footer.backgroundColor : activeTemplate.templateSetting.text.backgroundColor,
                                                                    fontSize: activeTemplate.templateSetting.footer.fontSize,
                                                                    lineHeight: `${activeTemplate.templateSetting.footer.fontSize}px`
                                                                }}>
                                                                    {webSettting.chatText}
                                                                </span>
                                                            </Col> :
                                                            null
                                                    }
                                                    <Col
                                                        span={STAYCHAT_WS_URL ? 8 : 12}
                                                        onClick={this.orderClicked}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            paddingTop: 14,
                                                            paddingBottom: 14,
                                                            cursor: 'pointer',
                                                            position: 'relative'
                                                        }}
                                                    >
                                                        <span style={{
                                                            position: 'absolute',
                                                            left: 0,
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            width: 2,
                                                            height: (activeTemplate.templateSetting.footer.fontSize || 16) + 'px',
                                                            backgroundColor: '#D9D9D9',
                                                            borderRadius: 1
                                                        }} />
                                                        {
                                                            menuText === 'order' ?
                                                                <OrderIcon
                                                                    style={{
                                                                        color: activeTemplate.templateSetting.footer.backgroundColor,
                                                                        fontSize: 25
                                                                    }}
                                                                />
                                                                :
                                                                <OrderIcon
                                                                    style={{
                                                                        fontSize: 25
                                                                    }}
                                                                />
                                                        }
                                                        <span style={{
                                                            marginLeft: 6,
                                                            fontFamily: activeTemplate.templateSetting.footer.fontFamily,
                                                            color: menuText === 'order' ? activeTemplate.templateSetting.footer.backgroundColor : activeTemplate.templateSetting.text.backgroundColor,
                                                            fontSize: activeTemplate.templateSetting.footer.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.footer.fontSize}px`
                                                        }}>
                                                            {webSettting.orderText}
                                                        </span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(FooterMenu)